import { render, staticRenderFns } from "./TotalExerciseCount.vue?vue&type=template&id=355bd69f&"
import script from "./TotalExerciseCount.vue?vue&type=script&lang=js&"
export * from "./TotalExerciseCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports